import { render, staticRenderFns } from "./StockSplit.vue?vue&type=template&id=e15566ae&"
import script from "./StockSplit.vue?vue&type=script&lang=ts&"
export * from "./StockSplit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports